import React from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Wave from 'react-wavify';
import '../assets/styles/Main.scss';
import fotoavatar from '../assets/images/fotoavatar.png';

function AnimatedWaves() {
  return (
    <div className="animated-waves" aria-hidden="true">
      <Wave
        className="wave wave-1"
        fill="url(#waveGradient1)"
        paused={false}
        options={{ height: 40, amplitude: 40, speed: 0.20, points: 4 }}
      >
        <defs>
          <linearGradient id="waveGradient1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#EE04F6" />
            <stop offset="50%" stopColor="#8C1BC3" />
            <stop offset="100%" stopColor="#362E96" />
          </linearGradient>
        </defs>
      </Wave>

      <Wave
        className="wave wave-2"
        fill="url(#waveGradient2)"
        paused={false}
        options={{ height: 60, amplitude: 30, speed: 0.15, points: 3 }}
      >
        <defs>
          <linearGradient id="waveGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#EE04F6" />
            <stop offset="100%" stopColor="#8C1BC3" />
          </linearGradient>
        </defs>
      </Wave>

      <Wave
        className="wave wave-3"
        fill="url(#waveGradient3)"
        paused={false}
        options={{ height: 80, amplitude: 25, speed: 0.25, points: 5 }}
      >
        <defs>
          <linearGradient id="waveGradient3" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#8C1BC3" />
            <stop offset="100%" stopColor="#362E96" />
          </linearGradient>
        </defs>
      </Wave>
    </div>
  );
}

function Main() {

  return (

    <div className="container">

      <div className="about-section">

        <AnimatedWaves />

        <div className="image-wrapper">

          <img src={fotoavatar} alt="João Farias Pinto" />

        </div>

        <div className="content">

          <div className="social_icons">

            <a href="https://www.linkedin.com/in/joao-pinto-/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>

          </div>

          <h1>João Farias Pinto</h1>

          <p>Marketing | Digital | Content</p>

          <div className="mobile_social_icons">

            <a href="https://www.linkedin.com/in/joao-pinto-/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>

          </div>

        </div>

      </div>

    </div>

  );

}

export default Main;